import { styled } from '@mui/material/styles'
import Avatar, { AvatarProps } from '@mui/material/Avatar'
import Box, { BoxProps } from '@mui/material/Box'
import MenuItem, { MenuItemProps } from '@mui/material/MenuItem'
import { Divider, DividerProps } from '@mui/material'

export const MenuAvatar = styled(Avatar)<AvatarProps>(({ theme }) => ({
  fontFamily: 'Roboto',
  width: 50,
  height: 50,
  fontSize: 16,
  backgroundColor: theme.palette.border?.secondary,
  color: theme.palette.text.primary
}))

export const HeaderMenuBox = styled(Box)<BoxProps>({
  display: 'flex',
  padding: 16,
  gap: 8
})

export const InfoUsuarioBox = styled(Box)<BoxProps>(({ theme }) => ({
  padding: 4,
  display: 'grid',
  gap: 4,

  h4: {
    fontFamily: 'Roboto',
    fontSize: 16,
    color: theme.palette.text.primary
  },

  span: {
    fontFamily: 'Roboto',
    fontSize: 12,
    color: theme.palette.text.primary
  }
}))

export const ItemMenu = styled(MenuItem)<MenuItemProps>(({ theme }) => ({
  minHeight: 48,
  h4: {
    fontFamily: 'Roboto',
    fontSize: 16,
    color: theme.palette.text.primary
  },
  svg: {
    color: theme.palette.text.primary,
    fontSize: 20
  }
}))

export const DividerMenu = styled(Divider)<DividerProps>(({ theme }) => ({
  borderColor: theme.palette.border?.primary
}))
